<div class="toast-container">
  <div *ngFor="let msg of messages" class="toast-item {{msg.severity}}" (click)="remove(msg.id)">
    <div class="toast-content">
      <div class="toast-icon">
        <i [class]="getIcon(msg.severity)"></i>
      </div>
      <div class="toast-text">
        <div class="toast-summary" *ngIf="msg.summary">{{msg.summary}}</div>
        <div class="toast-detail">{{msg.detail}}</div>
      </div>
      <div class="toast-close">
        <i class="pi pi-times"></i>
      </div>
    </div>
    <div class="toast-progress" *ngIf="!msg.sticky"></div>
  </div>
</div>
